import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";
import {Formatter} from "@/core/services/formatter.service";

export default class InvoiceBatchPaymentModel extends BaseModel {
  date = Formatter.getCurrentDate();
  method = null;
  description = null;
  bank_account = null;
  status = 'pending';
  fee_percent = null;
  invoices = []
  exchange_rate = null
  currency_uuid = null

  static TRANSLATABLE_FIELDS = [];

  rules = {
    date: 'required',
    method: 'required',
    bank_account: 'required',
  };

  attributeLabels = {
    date: i18n.t('Date'),
    method: i18n.t('Method'),
    description: i18n.t('Description'),
    bank_account: i18n.t('Bank Account'),
    status: i18n.t('Batch Status'),
    approved: i18n.t('Approve Batch Payment'),
    exchange_rate: i18n.t('Exchange Rate'),
    currency_uuid: i18n.t('Currency'),
    fee_percent: i18n.t('Fee Percent'),
  };

  attributeHints = {
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
